// Utility functions for storing and retrieving recent search terms in localStorage.

export const storeSearchTerms = (projectName, searchTerm, storageKey) => {
  if (!searchTerm) return;
  let storedData = {};
  const stored = localStorage.getItem(storageKey);
  if (stored) {
    storedData = JSON.parse(stored);
  }
  if (!Array.isArray(storedData[projectName])) {
    storedData[projectName] = [];
  }
  const terms = storedData[projectName];
  if (terms.includes(searchTerm)) return;
  if (terms.length >= 10) {
    terms.shift();
  }
  terms.push(searchTerm);
  try {
    localStorage.setItem(storageKey, JSON.stringify(storedData));
  } catch (e) {
    console.error('Failed to store data in localStorage:', e);
  }
};

export const getSearchTerms = (projectName, storageKey) => {
  const stored = localStorage.getItem(storageKey);
  if (!stored) return [];
  const parsedValues = JSON.parse(stored);
  if (!parsedValues || typeof parsedValues !== 'object') return [];

  const projectTerms = parsedValues[projectName];
  return Array.isArray(projectTerms) ? projectTerms : [];
};

export function isRecentlyUploadedFilter(filter) {
  return (
    _.isString(filter?.initialcreator) &&
    !_.isEmpty(filter.initialcreator) &&
    _.isEqual(filter.resourcetype, [2]) &&
    filter.refresourcetype == null
  );
}
